(() => {
  function patchSelects(personalizer) {
    return [...(personalizer?.querySelectorAll?.('[data-patch-title]') || [])];
  }

  function rawSelected(personalizer) {
    return patchSelects(personalizer).filter((select) => Boolean(select.value));
  }

  function sync(personalizer) {
    if (!personalizer) return;
    const selected = rawSelected(personalizer);
    personalizer.config = personalizer.config || {};
    personalizer.config.maxPatches = 2;
    if (selected.length) personalizer.patchesSelected = true;
    if (typeof personalizer.refresh === 'function') personalizer.refresh();
    if (typeof personalizer.updateSummary === 'function') personalizer.updateSummary();
    if (typeof personalizer.writeProperties === 'function') personalizer.writeProperties();
    if (typeof personalizer.save === 'function') personalizer.save();
  }

  function patchState(personalizer) {
    return rawSelected(personalizer).map((select) => ({
      group: select.closest('[data-patch-row]')?.dataset.patchGroup || '',
      value: select.value
    }));
  }

  document.addEventListener('click', (event) => {
    const card = event.target.closest?.('jersey-personalizer [data-patch-card]');
    if (!card) return;
    const personalizer = card.closest('jersey-personalizer');
    setTimeout(() => sync(personalizer), 0);
  }, true);

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('jersey-personalizer [data-patch-title]');
    if (!select) return;
    const personalizer = select.closest('jersey-personalizer');
    setTimeout(() => sync(personalizer), 0);
  }, true);

  window.JS360PatchTest = {
    state(personalizer = document.querySelector('jersey-personalizer.j360dr, jersey-personalizer[data-team]')) {
      if (!personalizer) return null;
      return {
        patchesSelected: Boolean(personalizer.patchesSelected),
        selections: patchState(personalizer),
        count: rawSelected(personalizer).length,
        summary: personalizer.querySelector('[data-personalizer-summary]')?.textContent?.trim() || '',
        feeItems: typeof personalizer.feeItems === 'function' ? personalizer.feeItems(1) : [],
        validation: typeof personalizer.validateSelections === 'function' ? personalizer.validateSelections() : ''
      };
    },
    sync
  };
})();
